import Vue from "vue";
import VueRouter from "vue-router";
import Routes from './config/Routes.js'


Vue.use(VueRouter)

export const routes = [
    ...Routes,
    {
        path: "/login",
        name: "login",
        component: () => import("@/views/SIBI/login/index.vue")
    },
    { // 错误页面
		path: '*',
		component: () => import('@/views/ErrorPage.vue')
	}
]
const router = new VueRouter({
	// mode: "history",
	mode: "hash",
	base: process.env.BASE_URL,
	routes,
});

//前置守卫(guard)
router.beforeEach((to, from, next) => {
    // const isAuthenticated = !!localStorage.getItem("token");
    
    // // 白名单路径
    // const whiteList = ['/login','/emailLogin' ,'/transfer/registerAccount' , '/transfer/forgetPassword'];
    
    // // 已登录状态访问登录页时重定向到首页
    // if (isAuthenticated && to.path === '/login') {
    //     return next({ name: 'HomePage' });
    // }
    
    // // 未登录且不在白名单时跳转登录
    // if (!isAuthenticated && !whiteList.includes(to.path)) {
    //     return next({
    //         path: '/login',
    //         // query: { redirect: to.fullPath } // 携带跳转来源路径
    //     });
    // }

    // if (to.meta.title) {
    //     document.title = i18n.t(to.meta.title)
    // }
    
    next();
});

export default router